var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIdle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.69 15.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #02222B;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.67,7.63c-2.28,1.65-2.87,5.28-2.87,5.28-.15.78.04,1.6.86,1.6h3.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.02,7.63c2.28,1.65,2.87,5.28,2.87,5.28.15.78-.04,1.6-.86,1.6h-3.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.67,7.63C1.39,5.97.8,2.35.8,2.35c-.15-.78.04-1.6.86-1.6h3.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.02,7.63c2.28-1.65,2.87-5.28,2.87-5.28.15-.78-.04-1.6-.86-1.6h-3.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.69,
    y1: 12.67,
    x2: 6.87,
    y2: 12.67
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdle);
export default __webpack_public_path__ + "static/media/icon_idle.ab829db4b7987ea9340c69c1b144981a.svg";
export { ForwardRef as ReactComponent };